import getConfig from 'next/config';
import { Page, TLD } from '@packages/common';

interface PublicConfig {
  APP_TLD: TLD;
  GTM_ID: string;
  ASSETS_URL: string;
  NODE_STATIC_ASSETS: string;
  FASTLANE_URL: string;
  PARTNER_LOGOS_URL: string;
  PUBLIC_DOMAIN: string;
  HOST_NAME: string;
  DATALAYER_NAME: string;
  PRODUCT_IMAGES_PATH: string;
  TRACKING_ENABLED: boolean;
  GOOGLE_AD_CHANNEL: string;
  TARGET_ENV: string;
  LOCALE: string;
  CONTENTFUL_DATA_SERVICE: string;
  PRODUCT_GRID_SLOT_CONFIGURATION: string;
  AB_TEST_CONFIG_URL: string;
  AFFINITIES_CONFIG_URL: string;
  ALGOLIA_APPLICATION_ID_1: string;
  ALGOLIA_SEARCH_API_KEY_1: string;
  ALGOLIA_APPLICATION_ID_2?: string;
  ALGOLIA_SEARCH_API_KEY_2?: string;
  SPLIO_API_BASE_URL: string;
  SPLIO_API_KEY: string;
  DYNAMIC_YIELD_ID: string;
  ROUTES: Record<string, Page>;
  USERCENTRICS_ID: string;
  USERCENTRICS_TEST_GROUP_ID: string;
  BRIDGE_URL: string;
  FACEBOOK_APPLICATION_ID: string;
  DYNAMIC_YIELD_RCOM_HOST: string;
  IS_E2E_TEST: boolean;
  DY_SERVER_SIDE_API_KEY: string;
  DY_CLIENT_SIDE_API_KEY: string;
}

const { publicRuntimeConfig } = getConfig();

export function getPublicRuntimeConfig<T extends keyof PublicConfig>(key: T): PublicConfig[T] {
  return publicRuntimeConfig[key];
}
